<template>
  <div>
    <v-row v-if="bookingStates.getBookingState()">
      <v-col class="col-12">
        <v-radio-group
          :value="bookingStates.getBookingState().state"
          row
          @change="changeBookingState"
        >
          <!-- waiting list -->
          <v-radio
            color="primary"
            :value="definitions.bookingState.waiting_list"
            :disabled="
              bookingStates.isConfirmed() || bookingStates.isReserved()
            "
          >
            <template #label>
              {{ $t('shopBackendBookingDetail.bookingStateWaitingList') }}
            </template>
          </v-radio>

          <!-- reserved -->
          <v-radio
            color="primary"
            :value="definitions.bookingState.reserved"
            :disabled="bookingStates.isConfirmed()"
          >
            <template #label>
              {{ $t('shopBackendBookingDetail.bookingStateProvisionally') }}
            </template>
          </v-radio>

          <!-- manual_confirmed -->
          <v-radio
            v-if="
              bookingStates.isManualConfirmed() ||
              !bookingStates.isAutoConfirmed()
            "
            color="primary"
            :value="definitions.bookingState.manual_confirmed"
          >
            <template #label>
              {{ $t('shopBackendBookingDetail.bookingStateManualConfirmed') }}
            </template>
          </v-radio>

          <!-- auto_confirmed -->
          <v-radio
            v-if="bookingStates.isAutoConfirmed()"
            color="primary"
            :value="definitions.bookingState.auto_confirmed"
          >
            <template #label>
              {{ $t('shopBackendBookingDetail.bookingStateAutoConfirmed') }}
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <!-- ask user to change the booking state -->
    <s-modal
      ref="changeBookingState"
      :size="1"
      persistent
      :ok-text="$t('bookingState.change')"
      :header-text="$t('bookingState.changeBookingState')"
      @ok="saveNewBookingState()"
      @cancel="resetOldBookingState()"
    >
      <v-row
        v-if="oldBookingStateString"
        class="headline-standard mt-8"
        :variables="
          (oldBookingState = bookingStates.getBookingStateByState(
            oldBookingStateString
          ))
        "
      >
        <!-- old booking state -->
        <v-col v-if="oldBookingState" class="col-5">
          {{ oldBookingState.title }}
        </v-col>

        <v-col class="col-1 text-center">
          <span class="fa fa-arrow-right" />
        </v-col>

        <!-- new booking state -->
        <v-col v-if="bookingStates.getBookingState()" class="col-6 text-right">
          {{ bookingStates.getBookingState().title }}
        </v-col>

        <!-- this change can't be undone -->
        <v-col class="col-12 mt-8 content-3">
          <span class="fal fa-exclamation-triangle mr-2 red--text" />
          {{ $t('bookingState.undoImpossible') }}
        </v-col>
      </v-row>
    </s-modal>
  </div>
</template>

<script>
import definitions from '../../../../definitions'
import BookingStates from '../../../classes-shared/bookings/BookingStates'

export default {
  name: 'BookingState',

  props: {
    bookingStates: {
      type: BookingStates,
      required: true,
    },

    // booking id, to save the new booking state
    bookingId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      definitions: definitions,
      oldBookingStateString: null,
    }
  },

  methods: {
    // booking state was changed via radio buttons
    async changeBookingState(newBookingStateString) {
      // save old booking state
      this.oldBookingStateString = this.bookingStates.getBookingState().state
      // set new booking state
      this.bookingStates.setBookingState(newBookingStateString)

      // open modal
      this.$refs.changeBookingState.show()
    },

    // save the new booking state to the api
    async saveNewBookingState() {
      // save booking state
      if (!(await this.bookingStates.saveBookingState(this.bookingId))) {
        this.resetOldBookingState()
      } else {
        this.$emit('updateBookingState')
        EventBus.$emit(
          'notify',
          this.$t('bookingState.stateChanged'),
          'success'
        )
      }
    },

    resetOldBookingState() {
      this.bookingStates.setBookingState(this.oldBookingStateString)
    },
  },
}
</script>
